import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";

import Page from "components/Page";
import { parseFormErrors } from "utils/formErrors";

import CategoryForm from "./components/CategoryForm";
import { CREATE_CATEGORY_MUTATION, MENU_CATEGORIES_QUERY } from "./categoryQueries";
import { PRODUCT_FORM_DATA_QUERY } from "../products/productQueries";
import { SELECT_OPTIONS_QUERY } from "../techCards/techCardQueries";

const NewCategory = ({ history }) => {
  const { t } = useTranslation();
  const [createCategory] = useMutation(CREATE_CATEGORY_MUTATION, {
    refetchQueries: [
      { query: MENU_CATEGORIES_QUERY },
      { query: PRODUCT_FORM_DATA_QUERY },
      { query: SELECT_OPTIONS_QUERY },
    ],
  });

  const handleSubmit = (values) =>
    createCategory({ variables: { object: values } })
      .then(() => history.goBack())
      .catch(parseFormErrors);

  return (
    <Page showBackIcon title={t("menu.MenuCategories.AddPage.Title")}>
      <Row>
        <Col xs={24} md={18} lg={14}>
          <Card>
            <CategoryForm t={t} onSubmit={handleSubmit} />
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

NewCategory.propTypes = {
  history: PropTypes.object.isRequired,
};

export default NewCategory;
